import { lang } from '@umu/ukit-lang';
/**
 * @description
 */

import React, { Component } from 'react';
import { getData } from '@umu/umu-util';
import { services, components } from 'common';
const { Toast } = services;
const { Textarea, If, Portal } = components;
import { saveMultimedia, updateMultimedia } from '@umu/umu-api';
import { IComment, IDocDraftCommentData } from '@umu/umu-types';
import PagePanel from '../@pagePanel/pagePanel';
import commentUtil from './commentUtil';
import { postThrottle } from '../../@utils/umuUtil';
import './docNoteComposer.scss';

export interface IProps {
    showNoteComposer: boolean;
    draftComment: IComment;
    draftCommentData: IDocDraftCommentData[];
    submitCommentSuccess(commentInfo: IComment): void;
}

export interface IState {
    rightClsName: string;
}

class DocNoteComposer<IP extends IProps, IS extends IState> extends Component<IP, IS> {
    public textareaPlaceholderMap: {
        [key: number]: string;
    } = {
        0: lang('添加笔记... \n长按文字内容，选择段落，将对应文字段落引用至笔记中，\n笔记记录更便捷。可返回尝试。'),
        1: lang('添加笔记...'),
    };
    public isSaveProcessing: boolean = false; // 是否保存中，避免按钮多次点击

    public title: string = lang('记笔记');
    public leftTitle: string = lang('返回');
    public rightTitle: string = lang('提交_POST');

    constructor(props: IP) {
        super(props);

        this.onBack = this.onBack.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.onSaveFail = this.onSaveFail.bind(this);
        this.onSaveSuccess = this.onSaveSuccess.bind(this);

        this.initState();
    }

    public UNSAFE_componentWillReceiveProps(nextProps: IP) {
        const props = nextProps;
        let rightClsName = '';

        const hasDraft = !commentUtil.isNoteDataEmpty(props.draftCommentData);

        if (hasDraft) {
            rightClsName = 'btn-link';
        }

        this.setState({
            rightClsName,
        });
    }

    public initState() {
        this.state = {} as IS;
    }

    public docCommentNote(comment: IDocDraftCommentData, index: number) {
        console.warn('override me', comment, index);
    }

    public docCommentClear() {
        console.warn('override me');
    }

    public onSaveSuccess(commentInfo: IComment) {
        this.props.submitCommentSuccess(commentInfo);
        this.docCommentClear();
        this.isSaveProcessing = false;
    }

    public onSaveFail() {
        this.isSaveProcessing = false;
    }

    public submitComment(multimediaId: number) {
        console.warn('override me', multimediaId, this.onSaveSuccess, this.onSaveFail);
    }

    public onSubmit() {
        if (this.isSaveProcessing) {
            return;
        }
        const props = this.props;
        const commentData = props.draftCommentData;
        if (!commentData || commentUtil.isNoteDataEmpty(commentData)) {
            Toast.show({
                message: lang('笔记内容为空，不能提交'),
            });
            return;
        }
        if (!postThrottle(JSON.stringify(commentData))) {
            return;
        }
        this.isSaveProcessing = true;
        const submitContent = commentUtil.getSubmitContent(commentData);
        const params = {
            content: submitContent,
            ref_type: 'comment',
            ref_id: 0,
            top_section_id: 0,
        };
        const commentExtend = getData(props.draftComment, 'extend');
        if (commentExtend && commentExtend.multimedia_id) {
            const prevMultimediaId = commentExtend.multimedia_id;
            params.top_section_id = prevMultimediaId;
            updateMultimedia(params).then(() => {
                this.submitComment(prevMultimediaId);
            });
        } else {
            saveMultimedia(params).then((response) => {
                const multimediaId = response.data.top_section_id;
                this.submitComment(multimediaId);
            });
        }
    }

    public onBack() {
        console.warn('override me');
    }

    public renderNoteUnit(comment: IDocDraftCommentData, index: number) {
        // 需要传动态传参数，所以这个地方需要每个textArea单独一个change方法
        const onChange = (content: string) => {
            this.docCommentNote(Object.assign({}, comment, { content }), index);
        };

        // 是否已编辑的状态，文本框placeholder不同
        const commentData = this.props.draftCommentData || [{}];
        const hasCommentDataEdited = commentData.length > 1 || !commentUtil.isNoteDataEmpty(commentData);
        const placeholder = this.textareaPlaceholderMap[Number(hasCommentDataEdited)];

        return (
            <div className="doc-note-composter-unit" key={index}>
                <If condition={!!comment.quote}>
                    <blockquote dangerouslySetInnerHTML={{ __html: comment.quote }}></blockquote>
                </If>
                <Textarea
                    isAutoExtend={true}
                    placeholder={placeholder}
                    value={comment.content || ''}
                    onBlur={onChange}
                ></Textarea>
            </div>
        );
    }

    public renderNoteContent() {
        const props = this.props;
        const commentData = props.draftCommentData || [{}];
        let noteList = null;
        if (commentData.length) {
            noteList = commentData.map((comment: IDocDraftCommentData, index: number) => {
                return this.renderNoteUnit(comment, index);
            });
        }
        return noteList;
    }

    public renderPanel() {
        if (!this.props.showNoteComposer) {
            return null;
        }

        return (
            <Portal preventBodyScroll={true}>
                <PagePanel
                    clsName={'doc-note-composer-holder'}
                    title={this.title}
                    leftTitle={this.leftTitle}
                    leftCallback={this.onBack}
                    leftClsName='uppercase'
                    rightTitle={this.rightTitle}
                    rightCallback={this.onSubmit}
                    rightClsName={this.state.rightClsName +' uppercase'}
                >
                    {this.renderNoteContent()}
                </PagePanel>
            </Portal>
        );
    }

    public render() {
        return this.renderPanel();
    }
}

export default DocNoteComposer;
